import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import AppShell from './components/layout/AppShell';
import LoginPage from './components/auth/LoginPage';
import DashboardPage from './components/dashboard/DashboardPage';
import JobsPage from './components/jobs/JobsPage';
import ActivityPage from './components/activity/ActivityPage';
import TasksPage from './components/tasks/TasksPage';
import VpsPage from './components/vps/VpsPage';
import CalendarPage from './components/calendar/CalendarPage';
import OrganizationPage from './components/organization/OrganizationPage';
import AgentsPage from './components/agents/AgentsPage';
import MemoryPage from './components/memory/MemoryPage';
import DocsPage from './components/docs/DocsPage';
import ApprovalsPage from './components/approvals/ApprovalsPage';
import ProjectsPage from './components/projects/ProjectsPage';
import ContentPage from './components/content/ContentPage';
import OfficePage from './components/office/OfficePage';
import SessionsPage from './components/sessions/SessionsPage';

function Placeholder({ title }: { title: string }) {
  return (
    <div className="flex items-center justify-center h-full">
      <div className="text-center">
        <h1 className="text-2xl font-semibold text-text-primary mb-2">{title}</h1>
        <p className="text-text-muted">Coming soon</p>
      </div>
    </div>
  );
}

function LoadingScreen() {
  return (
    <div className="min-h-screen bg-bg-primary flex items-center justify-center">
      <div className="text-text-muted">Loading...</div>
    </div>
  );
}

function ProtectedRoute() {
  const { user, loading } = useAuth();
  if (loading) return <LoadingScreen />;
  if (!user) return <Navigate to="/login" replace />;
  return <AppShell />;
}

export default function Router() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route element={<ProtectedRoute />}>
        {/* Phase 1 pages */}
        <Route path="/" element={<DashboardPage />} />
        <Route path="/jobs" element={<JobsPage />} />
        <Route path="/tasks" element={<TasksPage />} />
        <Route path="/activity" element={<ActivityPage />} />
        <Route path="/calendar" element={<CalendarPage />} />
        <Route path="/vps" element={<VpsPage />} />
        {/* Phase 2 pages */}
        <Route path="/projects" element={<ProjectsPage />} />
        <Route path="/content" element={<ContentPage />} />
        <Route path="/approvals" element={<ApprovalsPage />} />
        <Route path="/agents" element={<AgentsPage />} />
        <Route path="/organization" element={<OrganizationPage />} />
        <Route path="/office" element={<OfficePage />} />
        <Route path="/memory" element={<MemoryPage />} />
        <Route path="/docs" element={<DocsPage />} />
        <Route path="/sessions" element={<SessionsPage />} />
        <Route path="*" element={<Placeholder title="404 — Page Not Found" />} />
      </Route>
    </Routes>
  );
}
